import React, { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import logoLg from "../../../assets/images/lg-logo.png";
import cnfirmEmail from "../../../assets/images/confrim-email.png";
import axios from "../../../axios-instance";
import { notification } from "../../../utils/utility";

const ConfirmEmail = () => {
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email") || "";
  const [resending, setResending] = useState(false);

  const handleResend = () => {
    if (!email || resending) {
      return;
    }

    setResending(true);
    axios
      .post("/email-verification/resend", { email })
      .then((res) => {
        notification.success(
          res?.data?.message || "If needed, a new verification link has been sent."
        );
      })
      .catch((err) => {
        notification.error(
          err?.response?.data?.message || "Could not resend verification email. Please try again."
        );
      })
      .finally(() => setResending(false));
  };

  return (
    <div className="signup-process">
      <div className="logo-side">
        <img src={logoLg} alt="MeetOcto" />
      </div>
      <div className="signup">
        <div className="confirm-email">
          <img src={cnfirmEmail} alt="" />
          <h1>Email Sent!</h1>
          <p>Confirm your email to access your account.</p>
          {email ? (
            <p style={{ marginTop: 8, color: "#666", fontSize: 14 }}>
              We sent a link to <strong>{email}</strong>
            </p>
          ) : null}
          <div style={{ marginTop: 24, display: "flex", flexDirection: "column", gap: 12, alignItems: "center" }}>
            {email ? (
              <button
                type="button"
                onClick={handleResend}
                disabled={resending}
                style={{
                  background: "#FE9920",
                  color: "#fff",
                  border: "none",
                  borderRadius: 6,
                  padding: "10px 24px",
                  fontWeight: 600,
                  cursor: resending ? "not-allowed" : "pointer",
                }}
              >
                {resending ? "Sending..." : "Resend verification email"}
              </button>
            ) : null}
            <Link to="/admin/login" style={{ color: "#FE9920", fontWeight: 600 }}>
              Back to login
            </Link>
          </div>
        </div>
        <div className="signup-footer">
          <p>Copyright © {new Date().getFullYear()} MeetOcto.</p>
        </div>
      </div>
    </div>
  );
};

export default ConfirmEmail;
